"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchChannels = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var fetchChannels = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getChannels,
  initiatingActionType: _actions.ChannelActionTypes.LOAD_CHANNELS,
  requestStatusSelector: _selectors.getFetchChannelsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchChannels
}));
exports.fetchChannels = fetchChannels;